var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearning01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1334 994",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1333.33,993.75l-1333.33,-0c0,0 0,-763.614 0,-952.083c0,-11.051 4.39,-21.649 12.204,-29.463c7.814,-7.814 18.412,-12.204 29.463,-12.204c198.977,-0 1051.02,0 1250,0c11.05,-0 21.648,4.39 29.462,12.204c7.814,7.814 12.204,18.412 12.204,29.463c0,188.469 0,952.083 0,952.083Z",
    style: {
      fill: "#f4e8f0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.946,904.954c-305.86,0 -553.809,-16.842 -553.809,-37.62c-0,-20.779 247.949,-37.621 553.809,-37.621c305.862,0 553.81,16.842 553.81,37.621c-0,20.778 -247.948,37.62 -553.81,37.62Z",
    style: {
      fill: "#dbaf60",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.28,871.356l-501.905,-0c-13.15,-0 -23.81,-10.595 -23.81,-23.661l0,-663.919c0,-13.068 10.66,-23.661 23.81,-23.661l501.905,-0c13.147,-0 23.809,10.593 23.809,23.661l0,663.919c0,13.066 -10.662,23.661 -23.809,23.661Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.375,847.222l-138.095,0c-5.524,0 -10,-4.448 -10,-9.937l-0,-21.768c-0,-5.49 4.476,-9.938 10,-9.938l138.095,0c5.524,0 10,4.448 10,9.938l-0,21.768c-0,5.489 -4.476,9.937 -10,9.937Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.327,
    y: 211.222,
    width: 450,
    height: 566.437,
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.389,259.273c-38.195,-7.557 -75.595,16.659 -83.928,54.628c-8.429,38.4 16.062,76.321 54.704,84.699c18.248,3.957 36.391,0.612 51.343,-8.062l-36.081,-61.469l13.962,-69.796Z",
    style: {
      fill: "#f19f1f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.508,390.538c16.71,-9.691 29.438,-26.036 33.886,-46.3c3.991,-18.169 0.605,-36.229 -8.157,-51.104l-61.81,35.935l36.081,61.469Z",
    style: {
      fill: "#fdb740",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.694,259.539c-0.438,-0.095 -0.871,-0.18 -1.305,-0.266l-13.962,69.796l61.81,-35.935c-9.757,-16.565 -26.186,-29.182 -46.543,-33.595Z",
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.137,
    y: 262.802,
    width: 158.095,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.137,
    y: 324.32,
    width: 158.095,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 724.137,
    y: 390.57,
    width: 158.095,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.375,
    y: 466.285,
    width: 362.857,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.375,
    y: 537.267,
    width: 362.857,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.375,
    y: 608.249,
    width: 362.857,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.375,
    y: 688.695,
    width: 362.857,
    height: 24.607,
    style: {
      fill: "#fec766",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.52,657.368c3.995,4.524 11.004,4.373 17.042,3.848c4.267,-0.369 8.634,-0.767 12.534,-2.527c3.9,-1.761 7.319,-5.182 7.862,-9.403c0.624,-4.836 -2.505,-9.285 -5.576,-13.084c-6.162,-7.619 -18.429,-18.825 -27.667,-9.469c-5.581,5.654 -9.776,24.318 -4.195,30.635Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.63,438.052l-6.009,30.863l33.271,6.399l-0.448,-41.58l-26.814,4.318Z",
    style: {
      fill: "#eac2a6",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.04,383.833c-0,-0 -11.367,34.602 -1,50.392c10.367,15.79 35.676,12.34 35.676,12.34c0,0 12.781,-1.463 19.871,-10.88c6.158,-8.169 20.143,-10.532 24.015,-16.945c11.805,-19.556 2.086,-41.092 2.086,-41.092c-0,-0 -61.258,-26.575 -73.196,-12.444c-2.133,2.529 -7.452,18.629 -7.452,18.629Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.15,427.354l-4.562,8.332c0,-0 25.081,-7.264 29.5,-29.94c1.286,-6.597 5.867,-23.377 0.343,-35.465c-7.757,-16.949 -34.857,-30.353 -61.528,-21.251c-38.172,13.029 -16.896,22.098 -16.896,22.098c0,-0 18.748,11.772 34.595,4.692c11.32,-5.059 19.624,6.479 21.629,17.227l0.214,14.471l0.034,2.234l0.009,0.766c0,-0 10.8,-10.189 15.596,-3.136c4.795,7.057 -0.51,20.706 -16.453,15.449l-0.452,0.818l-2.029,3.705Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.199,490.996l-19.062,-5.026c-5.391,-1.419 -9.286,-6.066 -9.719,-11.59l-1.281,-16.451l-27.391,-17.977c0,0 -4.719,-4.734 5.138,-7.722l37.867,18.407c1.6,0.776 3.024,1.867 4.181,3.207l20.495,23.669l-10.228,13.483Z",
    style: {
      fill: "#fdd4b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.55,572.663c-2.828,-38.846 -7.442,-78.7 -15.171,-91.742c-10.681,-18.025 -52.329,-17.745 -52.329,-17.745c-0.09,0.081 -0.185,0.161 -0.276,0.238l-0.005,0c-16.428,13.995 -30.557,3.212 -32.4,1.678c-0.133,-0.109 -0.204,-0.174 -0.204,-0.174c-0,0 -15.586,-1.172 -30.529,7.497l-0.033,-0.034c-0.005,0.006 -0.048,0.048 -0.119,0.122c-0.067,0.037 -0.129,0.072 -0.195,0.11l-0.005,0.088c-1.619,1.616 -9.477,9.167 -21.319,16.085c-16.529,9.653 -32.81,13.647 -48.448,11.887l-54.971,-31.155l-15.572,27.133l60.124,34.066l2.847,0.445c5.039,0.786 9.967,1.145 14.772,1.145c24.462,0 45.586,-9.294 60.757,-18.758l-1.538,34.356l-0.005,0.099l-3.571,79.76l101.567,0l1.119,-80.442l10.033,80.442l28.476,0c-0.557,-15.237 -1.481,-34.152 -3.005,-55.101Z",
    style: {
      fill: "#7fa2d4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.75,461.468l9.5,1.669l-18.319,18.205l-7.666,-10.856l16.485,-9.018Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.58,470.485l-14.976,-7.247l-8.8,1.766l7.986,16.338l15.79,-10.857Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.14,477.141l9.376,-6.729l1.629,-0l5.671,7.664l-3.757,5.836l-10.1,-0l-2.819,-6.771Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.96,483.912l-14.095,97.103l11.038,14.703l13.157,-13.77l-0,-98.036l-10.1,-0Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.27,836.333c0,0 -11.819,12.697 -38.823,17.093c-5.167,0.842 -9.281,10.292 3.047,15.89c0,0 45.557,0.762 60.519,-6.653c6.395,-3.171 8.067,-15.209 -5.281,-25.984l-19.462,-0.346Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.39,836.348c-0,-0 2.833,8.825 29.467,9.686c5.381,0.175 20.966,9.687 7.652,18.517l-56.386,1.287c0,0 -17.857,-2.479 -2.833,-29.49l22.1,-0Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.76,627.651l19.724,212.851l-33.967,0l-23.886,-167.849c0,-1.377 -1.371,-2.531 -3.176,-2.673l-6.886,-0.81c-2.024,-0.156 -3.809,1.018 -3.895,2.565l-16.648,168.767l-39.628,0l12.681,-212.851l95.681,-0Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.013,852.645l-198.347,0c-11.286,0 -21.171,-6.038 -26.571,-15.029c-1.677,-2.792 -2.92,-5.878 -3.63,-9.152c-0.467,-2.106 -0.711,-4.292 -0.711,-6.535c0,-1.325 0.086,-2.636 0.25,-3.923c0.415,-3.232 1.342,-6.308 2.69,-9.147c4.953,-10.421 15.628,-17.651 27.972,-17.651l197.623,-0c-4.505,6 -7.309,11.929 -8.857,17.651c-0.843,3.113 -1.309,6.175 -1.471,9.147c-0.2,3.62 0.057,7.117 0.643,10.458c0.557,3.208 1.428,6.275 2.48,9.152c2.167,5.896 5.134,11.007 7.929,15.029Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.184,862.45l-206.518,0c-22.519,0 -40.777,-18.143 -40.777,-40.521c0,-11.192 4.565,-21.319 11.944,-28.653c7.38,-7.335 17.574,-11.869 28.833,-11.869l206.518,0c-3.514,3.275 -6.452,6.55 -8.895,9.801l-197.623,-0c-12.344,-0 -23.019,7.23 -27.972,17.651c-1.348,2.839 -2.275,5.915 -2.69,9.147c-0.164,1.287 -0.25,2.598 -0.25,3.923c0,2.243 0.244,4.429 0.711,6.535c0.71,3.274 1.953,6.36 3.63,9.152c5.4,8.991 15.285,15.029 26.571,15.029l198.347,0c4.281,6.18 8.171,9.805 8.171,9.805Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.833,793.276c-7.379,7.334 -11.944,17.461 -11.944,28.653c0,22.378 18.258,40.521 40.777,40.521l206.518,0l0,9.805l-206.518,0c-27.925,0 -50.642,-22.577 -50.642,-50.326c-0,-27.75 22.717,-50.327 50.642,-50.327l206.518,0l0,9.805l-206.518,0c-11.259,0 -21.453,4.534 -28.833,11.869Z",
    style: {
      fill: "#3464a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.432,808.859c-0.843,3.113 -1.309,6.175 -1.471,9.147l-217.957,-0c0.415,-3.232 1.342,-6.308 2.69,-9.147l216.738,-0Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.084,837.616l-216.989,-0c-1.677,-2.792 -2.92,-5.878 -3.63,-9.152l218.139,-0c0.557,3.208 1.428,6.275 2.48,9.152Z",
    style: {
      fill: "#bde2f5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.175,651.344l-198.347,0c-11.286,0 -21.171,-6.043 -26.571,-15.034c-1.677,-2.792 -2.92,-5.877 -3.631,-9.152c-0.467,-2.101 -0.71,-4.292 -0.71,-6.535c0,-1.325 0.086,-2.631 0.25,-3.918c0.415,-3.237 1.342,-6.308 2.69,-9.152c4.952,-10.42 15.627,-17.646 27.972,-17.646l197.623,0c-4.505,6 -7.314,11.925 -8.857,17.646c-0.843,3.119 -1.31,6.176 -1.476,9.152c-0.195,3.62 0.062,7.117 0.647,10.453c0.558,3.214 1.429,6.275 2.481,9.152c2.167,5.897 5.134,11.007 7.929,15.034Z",
    style: {
      fill: "#ffd68f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.346,661.145l-206.518,-0c-22.52,-0 -40.777,-18.143 -40.777,-40.522c-0,-11.186 4.564,-21.318 11.943,-28.653c7.38,-7.33 17.574,-11.868 28.834,-11.868l206.518,0c-3.514,3.275 -6.452,6.549 -8.895,9.805l-197.623,0c-12.345,0 -23.02,7.226 -27.972,17.646c-1.348,2.844 -2.275,5.915 -2.69,9.152c-0.164,1.287 -0.25,2.593 -0.25,3.918c0,2.243 0.243,4.434 0.71,6.535c0.711,3.275 1.954,6.36 3.631,9.152c5.4,8.991 15.285,15.034 26.571,15.034l198.347,0c4.281,6.176 8.171,9.801 8.171,9.801Z",
    style: {
      fill: "#f19f1f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.994,591.97c-7.379,7.335 -11.943,17.467 -11.943,28.653c-0,22.379 18.257,40.522 40.777,40.522l206.518,-0l0,9.805l-206.518,-0c-27.926,-0 -50.643,-22.573 -50.643,-50.327c0,-27.749 22.717,-50.326 50.643,-50.326l206.518,0l0,9.805l-206.518,0c-11.26,0 -21.454,4.538 -28.834,11.868Z",
    style: {
      fill: "#f19f1f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.594,607.553c-0.843,3.119 -1.31,6.176 -1.476,9.152l-217.952,0c0.415,-3.237 1.342,-6.308 2.69,-9.152l216.738,0Z",
    style: {
      fill: "#fdb740",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.246,636.31l-216.989,0c-1.677,-2.792 -2.92,-5.877 -3.631,-9.152l218.139,0c0.558,3.214 1.429,6.275 2.481,9.152Z",
    style: {
      fill: "#fdb740",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.061,751.997l-257.541,0c-11.286,0 -21.171,-6.043 -26.571,-15.034c-1.677,-2.792 -2.92,-5.877 -3.63,-9.152c-0.467,-2.106 -0.711,-4.292 -0.711,-6.535c0,-1.325 0.086,-2.631 0.25,-3.923c0.415,-3.232 1.342,-6.303 2.69,-9.147c4.953,-10.42 15.627,-17.646 27.972,-17.646l256.817,-0c-4.505,6 -7.314,11.925 -8.857,17.646c-0.843,3.118 -1.31,6.175 -1.476,9.147c-0.196,3.625 0.061,7.117 0.647,10.458c0.557,3.209 1.424,6.275 2.476,9.152c2.172,5.896 5.138,11.007 7.934,15.034Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.227,761.797l-265.707,0c-22.519,0 -40.777,-18.143 -40.777,-40.521c0,-11.187 4.564,-21.318 11.943,-28.653c7.38,-7.335 17.574,-11.868 28.834,-11.868l265.707,-0c-3.509,3.274 -6.447,6.549 -8.89,9.805l-256.817,-0c-12.345,-0 -23.019,7.226 -27.972,17.646c-1.348,2.844 -2.275,5.915 -2.69,9.147c-0.164,1.292 -0.25,2.598 -0.25,3.923c0,2.243 0.244,4.429 0.711,6.535c0.71,3.275 1.953,6.36 3.63,9.152c5.4,8.991 15.285,15.034 26.571,15.034l257.541,0c4.281,6.176 8.166,9.8 8.166,9.8Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.686,692.623c-7.379,7.335 -11.943,17.466 -11.943,28.653c0,22.378 18.258,40.521 40.777,40.521l265.707,0l0,9.805l-265.707,0c-27.926,0 -50.643,-22.572 -50.643,-50.326c0,-27.749 22.717,-50.326 50.643,-50.326l265.707,-0l0,9.805l-265.707,-0c-11.26,-0 -21.454,4.533 -28.834,11.868Z",
    style: {
      fill: "#62a0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.48,708.206c-0.843,3.118 -1.31,6.175 -1.476,9.147l-277.146,0c0.415,-3.232 1.342,-6.303 2.69,-9.147l275.932,-0Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.127,736.963l-276.178,0c-1.677,-2.792 -2.92,-5.877 -3.63,-9.152l277.332,0c0.557,3.209 1.424,6.275 2.476,9.152Z",
    style: {
      fill: "#8fc3e1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.451,868.479l-44.476,-12.394c-7.597,-2.115 -12.029,-9.951 -9.899,-17.499l76.611,-271.568c2.13,-7.548 10.016,-11.954 17.612,-9.838l44.476,12.393c7.597,2.115 12.029,9.952 9.899,17.499l-76.611,271.569c-2.13,7.547 -10.016,11.953 -17.612,9.838Z",
    style: {
      fill: "#527fbd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.12,642.207l-71.986,-20.055l4.628,-16.402l71.986,20.055l-4.628,16.402Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.408,669.544l-71.987,-20.055l4.628,-16.401l71.986,20.055l-4.627,16.401Z",
    style: {
      fill: "#e9f7fe",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning01);
export default __webpack_public_path__ + "static/media/learning-01.4351490fceba6e7467fbe23dcdac9b10.svg";
export { ForwardRef as ReactComponent };